<ng-template #faqTemplateHeader>
  <a routerLink="/faq">Accéder à la FAQ</a>
</ng-template>
<ng-template #faqTemplateContent>
  @for (article of (articles | sort:'id':true).slice(0, 3); track article) {
    <a
      [title]="article.title.rendered | urldecode"
      class="content-grid p-3"
      [routerLink]="['/faq', article.id]">
      <div>{{ article.title.rendered | urldecode }}</div>
      <div class="d-flex flex-grow-1 justify-content-end">
        @for (cid of article.categories; track cid) {
          <span style="display: contents">
            @if (getCategoryById(cid); as c) {
              <app-badge class="me-1 ms-1"
                [label]="{id: 0, textcolor: c.textcolor, backcolor: c.backcolor, name: c.name}">
              </app-badge>
            }
          </span>
        }
      </div>
    </a>
  }
</ng-template>
<app-dash-block title="Foire aux questions" [error]="error" [headerTemplate]="faqTemplateHeader"
  [contentTemplate]="articles ? faqTemplateContent : null">
</app-dash-block>
